// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__v2GFF","subject":"styles_subject__lp6VH","textEditor":"styles_textEditor__EOYOe"};